var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"j-end align-center"},[_c('total'),_c('btn-movimientos-entre-cajas'),_c('btn-resumen-caja')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }